import React, { useRef } from 'react'
import { useGSAP } from '@gsap/react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger);


const Nophotocouple = ({details}) => {

   const sectionRef = useRef(null);
    const backgroundRef = useRef(null);
    const cardRef = useRef(null);

    useGSAP(() => {
    
      if (!backgroundRef.current && !cardRef.current) return;
    
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 85%",
          once: true,
        },
      });
    
      // Floral background
      if (backgroundRef.current) {
        tl.fromTo(
          backgroundRef.current,
          {
            opacity: 0,
          },
          {
            opacity: 1,
            duration: 1,
            ease: "power2.out",
          }
        );
      }
    
      // Red card
      if (cardRef.current) {
        tl.fromTo(
          cardRef.current,
          {
            opacity: 0,
          },
          {
            opacity: 1,
            duration: 0.9,
            ease: "power2.out",
          },
          "-=0.5"
        );
      }
    
    }, {
      scope: sectionRef,
    });
    

   const renderPersonCard = ({
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  }) => {
    return (
      <div className="t5-single-couple-container" data-aos="fade-up">

        <div className="t5-couple-grandparents">
          {grandParentsName && (
  <p>
    {grandParentsPrefix} {grandParentsName}
  </p>
)}
        </div>

        <h1 className="t5-couple-name">
          {fullname}
        </h1>

        <div className="t5-couple-parents">
        {parentsName && (
  <p>
    {parentprefix} {parentsName}
  </p>
)}
        </div>

      </div>
    );
  };

  const groomCard = () =>
    renderPersonCard({
      fullname: details?.groomFullName || "Groom Full Name",
      parentprefix: details?.groomParentsPrefix,
      parentsName: details?.groomParents,
      grandParentsPrefix: details?.groomGrandParentsPrefix,
      grandParentsName: details?.groomGrandParents,
    });

  const brideCard = () =>
    renderPersonCard({
      fullname: details?.brideFullName || "Bride Full Name",
      parentprefix: details?.brideParentsPrefix,
      parentsName: details?.brideParents,
      grandParentsPrefix: details?.brideGrandParentsPrefix,
      grandParentsName: details?.brideGrandParents,
    });


  return (
    <section className="couple-section no-photo-couple theme5"  ref={sectionRef} >
        <div className="theme5-middle-section-bg"  ref={backgroundRef}>
          <div className="theme5-couple-card " ref={cardRef}>
          <div className="theme5-nocouple-inner-content">
                         <h1 className="t5-couple-heading" data-aos="fade-up"  >
                 {details?.sectionHeading}
          </h1>
            <div className="t5-couple-wrapper">

            {details?.displayOrder === "groomFirst" ? (
                    <>
                      {groomCard()}
                          <span className="t5-couple-divider" data-aos="fade-up">
                        &
                    </span>
                    {brideCard()}
                    </>
                   ) : ( <>
                       {brideCard()}
                         <span className="t5-couple-divider" data-aos="fade-up">
                        &
                    </span>
                    {groomCard()}
                   </>) }
            </div>
          </div>
            
          
          </div>

        </div>
    </section>
  )
}

export default Nophotocouple